import { Component, Input, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import Moment from "moment";

import { ApiService } from "src/app/api.service";
import { DatetimePipe } from "src/app/pipes";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-vibe-check",
	templateUrl: "./vibe-check.component.html",
	styleUrls: ["./vibe-check.component.scss"],
	imports: [ActionButtonComponent, FormsModule, DatetimePipe]
})
export class VibeCheckComponent implements OnInit {
	api = inject(ApiService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	vibecheck: APIResults.VibeCheck;

	public checkresults: APIResults.VibeCheckResultRow[];
	public error: string;

	public logs: APIResults.VibeCheckAck[];
	public newSummary: string;

	async ngOnInit(): Promise<void> {
		this.RefreshCheck();
		this.RefreshLogs();
	}

	async RefreshCheck(): Promise<void> {
		this.error = undefined;
		this.checkresults = undefined;
		try {
			const checkresults = await this.api.GetVibeCheck(this.asset.asset_id);
			this.checkresults = checkresults;
		} catch (err) {
			this.error = "Unable to load vibe check";
			console.error("Unable to load vibe check");
			console.log(err);
		}
	}

	async RefreshLogs(): Promise<void> {
		this.error = undefined;
		this.logs = undefined;
		try {
			const logs = await this.api.GetVibeCheckAcks(this.asset.asset_id);
			this.logs = logs;
		} catch (err) {
			console.error("Unable to load acknowledgement logs");
			console.log(err);
		}
	}

	DownloadData() {
		let output = "Name,CI Date,IPS,Warning,Alarm\n";
		for (const row of this.checkresults) {
			const pretty = Moment(row.date).toISOString();
			output += '"' + row.name + '","' + pretty + '",' + row.value + "," + row.warn + "," + row.alarm + "\n";
		}
		this.api.DownloadFile(this.asset.asset_name + "_" + Moment().format("YYYY-MM-DD HHmmss") + "_" + this.vibecheck.name + ".csv", output);
	}

	async SaveAcknowledgement() {
		await this.api.UploadVibeCheckAck(this.asset.asset_id, this.newSummary);
		await this.RefreshLogs();
		this.newSummary = undefined;
	}

	async DeleteAcknowledgement(id: number) {
		await this.api.DeleteVibeCheckAck(this.asset.asset_id, id);
		await this.RefreshLogs();
	}
}
